<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">
  
  <div class="content-section">
    <h2>L'assurance tous risques chantier (TRC)</h2>
    <p>
      L'<strong>assurance tous risques chantier</strong> protège les travaux de construction pendant toute la durée du chantier, 
      du début des travaux jusqu'à leur réception. Elle couvre les <strong>dommages matériels</strong> affectant les ouvrages 
      en cours de construction, quelle qu'en soit la cause (incendie, tempête, vol, vandalisme, erreur de mise en œuvre...).
    </p>
    <p>
      Cette assurance est <strong>fortement recommandée</strong> pour les maîtres d'ouvrage (particuliers, promoteurs, entreprises) 
      et les constructeurs. Elle évite les litiges entre intervenants en cas de sinistre pendant le chantier, 
      et permet de reprendre rapidement les travaux.
    </p>
  </div>

  <div class="content-section bg-info">
    <div class="info-box">
      <i class="pi pi-info-circle"></i>
      <div>
        <h3>💡 TRC : Une assurance non obligatoire mais vivement conseillée</h3>
        <p>
          Contrairement à l'assurance décennale (obligatoire pour les constructeurs) ou dommages-ouvrage (obligatoire pour le maître d'ouvrage), 
          la TRC est <strong>facultative</strong>. Toutefois, elle est <strong>systématiquement souscrite</strong> pour les chantiers importants 
          (construction d'immeubles, équipements publics, ouvrages complexes).
        </p>
        <p>
          <strong>Avantage majeur :</strong> En cas de sinistre pendant le chantier, l'assurance TRC indemnise sans rechercher le responsable. 
          Cela évite les conflits entre corps de métier et permet de reprendre les travaux rapidement.
        </p>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Qui peut souscrire une assurance TRC ?</h2>
    <div class="subscribers">
      <div class="subscriber-type">
        <h3>🏗️ Maître d'ouvrage</h3>
        <p><strong>Le plus fréquent</strong></p>
        <p>Le maître d'ouvrage (particulier, promoteur, entreprise, collectivité) souscrit une TRC pour protéger 
        son projet pendant toute la durée du chantier.</p>
        <ul>
          <li>Particuliers faisant construire</li>
          <li>Promoteurs immobiliers</li>
          <li>Entreprises construisant leurs locaux</li>
          <li>Collectivités (écoles, mairies, gymnases)</li>
        </ul>
      </div>

      <div class="subscriber-type">
        <h3>👷 Entrepreneur général</h3>
        <p>L'entreprise générale pilotant le chantier peut souscrire une TRC pour couvrir l'ensemble des travaux, 
        y compris ceux réalisés par les sous-traitants.</p>
      </div>

      <div class="subscriber-type">
        <h3>🏢 Plusieurs co-souscripteurs</h3>
        <p>Il est possible de souscrire une TRC en commun (maître d'ouvrage + entreprises), 
        avec une police unique couvrant tous les intervenants.</p>
      </div>
    </div>
  </div>

  <div class="content-section bg-light">
    <h2>Tarification selon le type de chantier</h2>
    <div class="pricing-trc">
      <div class="trc-pricing-card">
        <h3>🏠 Maison individuelle</h3>
        <div class="pricing-detail">
          <p><strong>Base de calcul :</strong> 0,3% à 0,8% du coût TTC des travaux</p>
          <div class="price-examples">
            <div class="price-line">
              <span>Maison 150m² (300 000€ TTC)</span>
              <span class="price">900€ - 2 400€</span>
            </div>
            <div class="price-line">
              <span>Maison 200m² (450 000€ TTC)</span>
              <span class="price">1 350€ - 3 600€</span>
            </div>
          </div>
          <p class="note">Prime payée en une fois au début du chantier</p>
        </div>
      </div>

      <div class="trc-pricing-card">
        <h3>🏢 Immeuble collectif</h3>
        <div class="pricing-detail">
          <p><strong>Base de calcul :</strong> 0,5% à 1,2% du coût TTC des travaux</p>
          <div class="price-examples">
            <div class="price-line">
              <span>Immeuble 10 logements (2M€ TTC)</span>
              <span class="price">10 000€ - 24 000€</span>
            </div>
            <div class="price-line">
              <span>Immeuble 30 logements (6M€ TTC)</span>
              <span class="price">30 000€ - 72 000€</span>
            </div>
          </div>
          <p class="note">Tarif dégressif selon taille et complexité</p>
        </div>
      </div>

      <div class="trc-pricing-card">
        <h3>🏭 Locaux professionnels / Industriels</h3>
        <div class="pricing-detail">
          <p><strong>Base de calcul :</strong> 0,6% à 1,5% du coût TTC des travaux</p>
          <div class="price-examples">
            <div class="price-line">
              <span>Bureaux 1000m² (1,5M€ TTC)</span>
              <span class="price">9 000€ - 22 500€</span>
            </div>
            <div class="price-line">
              <span>Entrepôt 5000m² (3M€ TTC)</span>
              <span class="price">18 000€ - 45 000€</span>
            </div>
            <div class="price-line">
              <span>Usine complexe (10M€ TTC)</span>
              <span class="price">60 000€ - 150 000€</span>
            </div>
          </div>
        </div>
      </div>

      <div class="trc-pricing-card">
        <h3>🌉 Ouvrages d'art / Infrastructures</h3>
        <div class="pricing-detail">
          <p><strong>Base de calcul :</strong> 0,8% à 2% du coût TTC des travaux</p>
          <div class="price-examples">
            <div class="price-line">
              <span>Pont / Passerelle (5M€ TTC)</span>
              <span class="price">40 000€ - 100 000€</span>
            </div>
            <div class="price-line">
              <span>Station d'épuration (20M€ TTC)</span>
              <span class="price">160 000€ - 400 000€</span>
            </div>
          </div>
          <p class="note">Risques élevés, tarifs plus importants</p>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Les garanties de l'assurance TRC</h2>
    <div class="guarantees-trc">
      <div class="guarantee-block base">
        <h3>🔷 Garanties de base</h3>
        <div class="guarantee-items">
          <div class="guarantee-item">
            <i class="pi pi-bolt"></i>
            <div>
              <h4>Dommages matériels aux ouvrages</h4>
              <p>Incendie, explosion, foudre, dégâts des eaux, tempête, grêle, neige</p>
              <p><strong>Exemple :</strong> Incendie détruisant une partie du bâtiment en construction</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-exclamation-triangle"></i>
            <div>
              <h4>Catastrophes naturelles</h4>
              <p>Inondations, coulées de boue, tremblements de terre, avalanches</p>
              <p><strong>Exemple :</strong> Inondation du chantier suite à fortes pluies</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-users"></i>
            <div>
              <h4>Erreurs de conception ou de mise en œuvre</h4>
              <p>Malfaçons, défauts de matériaux, erreurs d'exécution découverts pendant le chantier</p>
              <p><strong>Exemple :</strong> Effondrement d'un mur mal construit avant réception</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-ban"></i>
            <div>
              <h4>Vol et vandalisme</h4>
              <p>Vol de matériaux, d'équipements, dégradations volontaires</p>
              <p><strong>Exemple :</strong> Vol de câbles électriques et cuivre sur le chantier</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-cog"></i>
            <div>
              <h4>Chute, choc, bris accidentel</h4>
              <p>Dommages causés par engins de chantier, chute de matériaux, erreurs de manutention</p>
              <p><strong>Exemple :</strong> Engin de chantier endommageant une partie construite</p>
            </div>
          </div>
        </div>
      </div>

      <div class="guarantee-block optional">
        <h3>💎 Garanties optionnelles (extensions)</h3>
        <div class="guarantee-items">
          <div class="guarantee-item">
            <i class="pi pi-dollar"></i>
            <div>
              <h4>Frais de déblaiement</h4>
              <p>Coûts de nettoyage, démolition, évacuation des décombres après sinistre</p>
              <p class="cost">+0,1% à +0,2% du coût travaux</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-money-bill"></i>
            <div>
              <h4>Frais supplémentaires (surcoûts consécutifs)</h4>
              <p>Augmentation des coûts due à l'arrêt du chantier, hausse des prix matériaux</p>
              <p class="cost">+0,1% à +0,3% du coût travaux</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-clock"></i>
            <div>
              <h4>Maintien de garantie après réception</h4>
              <p>Extension de la couverture 1 à 3 mois après réception (période test)</p>
              <p class="cost">+0,05% à +0,1% du coût travaux</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-wrench"></i>
            <div>
              <h4>Matériels et engins de chantier</h4>
              <p>Couverture spécifique pour les engins utilisés sur le chantier</p>
              <p class="cost">+0,2% à +0,4% du coût travaux</p>
            </div>
          </div>

          <div class="guarantee-item">
            <i class="pi pi-shield"></i>
            <div>
              <h4>RC vis-à-vis des existants</h4>
              <p>Dommages causés aux constructions voisines ou préexistantes</p>
              <p class="cost">+0,1% à +0,2% du coût travaux</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section bg-accent">
    <h2>Exclusions de la TRC</h2>
    <div class="exclusions-list">
      <div class="exclusion">
        <i class="pi pi-times-circle"></i>
        <h4>Dommages immatériels</h4>
        <p>Pertes financières, retards de chantier, pénalités de retard (non couverts par la TRC, 
        nécessitent une assurance perte d'exploitation chantier)</p>
      </div>

      <div class="exclusion">
        <i class="pi pi-times-circle"></i>
        <h4>Usure normale et vices cachés</h4>
        <p>Défauts de conception non découverts pendant le chantier (couverts par garantie décennale après réception)</p>
      </div>

      <div class="exclusion">
        <i class="pi pi-times-circle"></i>
        <h4>Dommages volontaires</h4>
        <p>Dégradations intentionnelles par le maître d'ouvrage ou les constructeurs</p>
      </div>

      <div class="exclusion">
        <i class="pi pi-times-circle"></i>
        <h4>Guerre, émeute, actes de terrorisme</h4>
        <p>Sauf souscription d'une extension spécifique</p>
      </div>

      <div class="exclusion">
        <i class="pi pi-times-circle"></i>
        <h4>Matériaux ou équipements avant incorporation</h4>
        <p>Vol ou dommages aux matériaux stockés hors chantier (nécessitent assurance spécifique)</p>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Critères d'évaluation de la prime</h2>
    <div class="premium-factors-trc">
      <div class="factor-item">
        <h3>💰 Coût total des travaux</h3>
        <p>La prime TRC est calculée en pourcentage du montant TTC des travaux. 
        Plus le projet est coûteux, plus la prime est élevée (mais le pourcentage peut être dégressif).</p>
        <div class="examples-list">
          <div class="example">Chantier 500k€ : 0,8% = 4 000€</div>
          <div class="example">Chantier 5M€ : 0,6% = 30 000€ (dégressif)</div>
        </div>
      </div>

      <div class="factor-item">
        <h3>🏗️ Type et complexité du chantier</h3>
        <ul>
          <li><strong>Maison plain-pied simple :</strong> Tarif de base (0,3% à 0,5%)</li>
          <li><strong>Immeuble collectif :</strong> Tarif moyen (0,5% à 1%)</li>
          <li><strong>Ouvrage complexe (architecture spéciale, techniques innovantes) :</strong> Surprime +0,3% à +0,5%</li>
          <li><strong>Ouvrage d'art, infrastructure :</strong> Tarif élevé (0,8% à 2%)</li>
        </ul>
      </div>

      <div class="factor-item">
        <h3>📍 Localisation du chantier</h3>
        <ul>
          <li><strong>Zone sismique :</strong> Surprime +0,2% à +0,5%</li>
          <li><strong>Zone inondable :</strong> Surprime +0,2% à +0,4%</li>
          <li><strong>Chantier urbain dense (risques tiers) :</strong> Surprime +0,1% à +0,3%</li>
          <li><strong>Chantier isolé, mal sécurisé :</strong> Risque vol élevé, surprime +0,2% à +0,5%</li>
        </ul>
      </div>

      <div class="factor-item">
        <h3>⏱️ Durée du chantier</h3>
        <ul>
          <li><strong>Chantier court (3 à 6 mois) :</strong> Tarif de base</li>
          <li><strong>Chantier long (12 à 24 mois) :</strong> Surprime +0,2% à +0,4% (risques cumulés)</li>
          <li><strong>Chantier très long (&gt; 24 mois) :</strong> Prime annuelle renouvelable</li>
        </ul>
      </div>

      <div class="factor-item">
        <h3>👷 Qualité des intervenants</h3>
        <ul>
          <li><strong>Entreprises qualifiées (Qualibat, RGE) :</strong> Réduction -0,1% à -0,2%</li>
          <li><strong>Bureau de contrôle obligatoire :</strong> Réduction -0,2% à -0,3%</li>
          <li><strong>Coordination SPS (sécurité) :</strong> Réduction -0,1%</li>
          <li><strong>Sous-traitants non assurés :</strong> Surprime ou refus</li>
        </ul>
      </div>

      <div class="factor-item">
        <h3>🔒 Mesures de sécurité</h3>
        <ul>
          <li><strong>Gardiennage 24/7 :</strong> Réduction vol -0,1% à -0,2%</li>
          <li><strong>Clôture sécurisée du chantier :</strong> Réduction -0,05% à -0,1%</li>
          <li><strong>Télésurveillance :</strong> Réduction -0,1%</li>
          <li><strong>Stockage sécurisé des matériaux :</strong> Réduction -0,05%</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="content-section bg-light">
    <h2>Exemple de calcul détaillé</h2>
    <div class="example-calc-trc">
      <div class="calc-header-trc">
        <h3>🏢 Construction immeuble 15 logements - Province</h3>
        <p><strong>Coût total travaux :</strong> 3 000 000€ TTC | <strong>Durée :</strong> 18 mois | <strong>Zone non sismique</strong></p>
      </div>
      <div class="calc-details-trc">
        <div class="calc-row">
          <span>Prime de base (0,8% du coût TTC)</span>
          <span>24 000€</span>
        </div>
        <div class="calc-row">
          <span>+ Chantier urbain centre-ville (+0,2%)</span>
          <span>+6 000€</span>
        </div>
        <div class="calc-row">
          <span>+ Durée 18 mois (+0,1%)</span>
          <span>+3 000€</span>
        </div>
        <div class="calc-row">
          <span>+ Extension frais de déblaiement (+0,1%)</span>
          <span>+3 000€</span>
        </div>
        <div class="calc-row reduction">
          <span>- Bureau de contrôle obligatoire (-0,2%)</span>
          <span>-6 000€</span>
        </div>
        <div class="calc-row reduction">
          <span>- Entreprises qualifiées Qualibat (-0,15%)</span>
          <span>-4 500€</span>
        </div>
        <div class="calc-row reduction">
          <span>- Gardiennage + clôture sécurisée (-0,15%)</span>
          <span>-4 500€</span>
        </div>
        <div class="calc-row total">
          <span><strong>Prime totale TRC</strong></span>
          <span class="final-price-trc">21 000€</span>
        </div>
        <div class="calc-note-trc">
          <p><strong>Soit :</strong> 0,7% du coût total des travaux</p>
          <p><strong>Paiement :</strong> Prime unique au début du chantier (couverture jusqu'à réception)</p>
        </div>
      </div>
    </div>
  </div>

  <div class="content-section">
    <h2>Pourquoi souscrire une TRC ?</h2>
    <div class="benefits-trc">
      <div class="benefit-card">
        <i class="pi pi-check-circle"></i>
        <h4>Protection complète pendant le chantier</h4>
        <p>La TRC couvre tous les risques matériels pendant la phase la plus vulnérable : la construction. 
        Cela évite de devoir reconstruire à vos frais en cas de sinistre.</p>
      </div>

      <div class="benefit-card">
        <i class="pi pi-users"></i>
        <h4>Évite les conflits entre intervenants</h4>
        <p>En cas de sinistre, l'assurance TRC indemnise sans rechercher le responsable. 
        Pas de litiges entre maçon, électricien, plombier... Le chantier reprend rapidement.</p>
      </div>

      <div class="benefit-card">
        <i class="pi pi-clock"></i>
        <h4>Reprise rapide des travaux</h4>
        <p>Indemnisation rapide en cas de sinistre (30 à 60 jours). Les travaux peuvent reprendre sans attendre 
        des mois de procédures pour désigner le responsable.</p>
      </div>

      <div class="benefit-card">
        <i class="pi pi-shield"></i>
        <h4>Complément à la décennale et DO</h4>
        <p>La décennale couvre après réception (10 ans), la DO préfinance les réparations après réception. 
        La TRC couvre <strong>pendant</strong> le chantier. Les trois assurances sont complémentaires.</p>
      </div>

      <div class="benefit-card">
        <i class="pi pi-money-bill"></i>
        <h4>Rassure les financeurs</h4>
        <p>Banques et investisseurs exigent souvent une TRC pour les chantiers importants. 
        Cela sécurise le financement et prouve votre sérieux.</p>
      </div>

      <div class="benefit-card">
        <i class="pi pi-file"></i>
        <h4>Exigée par certains maîtres d'ouvrage</h4>
        <p>Les promoteurs, collectivités et entreprises imposent systématiquement une TRC dans les marchés de travaux. 
        Sans TRC, vous ne pouvez pas soumissionner.</p>
      </div>
    </div>
  </div>

  <div class="content-section cta-section">
    <h2>Protégez votre chantier avec une assurance TRC</h2>
    <p>Comparez les offres d'assurance tous risques chantier</p>
    <button class="btn-primary" routerLink="/cac/comparaison">Comparer les offres</button>
  </div>
</app-page-layout>
